import React, { useEffect, useRef } from 'react';
import { toast } from 'react-toastify';
import socket, { connectSocket } from '../utils/socket';

const NOTIFICATION_SOUND_URL = 'https://assets.mixkit.co/active_storage/sfx/2869/2869-preview.mp3';

const NotificationHandler = () => {
    const audioRef = useRef(null);

    useEffect(() => {
        const token = localStorage.getItem('zTaskAuthToken');
        if (!token) return undefined;

        connectSocket();

        const handleNotification = (data) => {
            if (audioRef.current) {
                audioRef.current.play().catch(() => { /* autoplay blocked */ });
            }
            toast.info(data.message, {
                position: 'top-right',
                autoClose: 6000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                theme: 'colored',
            });
        };

        socket.on('notification', handleNotification);

        return () => {
            socket.off('notification', handleNotification);
            socket.disconnect();
        };
    }, []);

    return (
        <audio ref={audioRef} src={NOTIFICATION_SOUND_URL} preload="auto" />
    );
};

export default NotificationHandler;
